import { createFileRoute, Outlet } from '@tanstack/react-router';
import { MaintenanceGate } from '../../../components/shell/maintenance-gate';
import { ensureSubdomain } from '../../../utils/subdomain';

// The client portal: everything under app.<domain>. Anything reached on another host is bounced here.
export const Route = createFileRoute('/subdomain/app')({
  beforeLoad: ensureSubdomain('app'),
  component: () => (
    <MaintenanceGate>
      <Outlet />
    </MaintenanceGate>
  ),
});
